module.exports = __webpack_public_path__ + "img/bazarDark.85f079bb.svg";